import styled from '@emotion/styled';
import { IconButton, Dialog } from '@mui/material';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';

export const TitleStyled = styled.title`
text-transform: capitalize;
`;


export const WrapperQuiz = styled.div`
position: relative;
`;

export const TitleQuiz = styled('h2')(({ theme }) => `
text-transform: capitalize;
margin-bottom: 10px;
color: ${theme.palette.text.black};
`);

export const WrapperNameBtnExit = styled('div')(() => `
display: flex;
flex-wrap: wrap;
justify-content: center;
align-items: baseline;
gap: 10px;
margin-bottom: 10px;
`);

export const NameStudent = styled('h3')(({ theme }) => `
color: ${theme.palette.text.black};
`);

export const BackdropTimer = styled(Dialog)(({ theme }) =>
   ` 
   background-color: rgba(0, 0, 0, 0.85);
   & .MuiDialog-paper{
   background-color: rgba(0, 0, 0, 0.2);
   border-radius: 50%;
   color: ${theme.palette.secondary.main};
   & :hover{
 background-color: rgba(0, 0, 0, 0.2);
   };
   & * :hover {     
     color: ${theme.palette.secondary.dark}; 
   }
}
`);

export const PlayTimerButton = styled(IconButton)(({ theme }) => `
color: ${theme.palette.background.primary};
/* padding: 2px;
@media (min-width: 600px){
padding: 6px;
} */
`);

export const PlayIconStyled = styled(PlayCircleOutlineIcon)(() => `
font-size: 60px; 
// @media (min-width: 600px){
//    font-size: 40px; 
// }
`);

export const BreakIconStyled = styled(PauseCircleOutlineIcon)(() => `
font-size: 30px; 
@media (min-width: 600px){
   font-size: 40px; 
}
`);

export const WrapperQuestions = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: stretch ;
gap:20px;
margin-bottom: 20px;
`;

export const WrapperArrowButtonStyled = styled.div`
position: fixed;
top: 50%;
right: 15px;
display: flex;
flex-direction:column;
gap: 4px;
@media (min-width: 600px) and (max-width: 1280px){
   right: 16px; 
}
@media (min-width: 1281px) {
   right: calc((100vw - 1280px) / 2 + 16px); 
}
`;

export const ArrowButtonStyled = styled(IconButton)(({ theme }) => `
color: ${theme.palette.background.primary};
padding: 2px;
@media (min-width: 600px){
padding: 6px;
}
`);

export const ArrowUpIconStyled = styled(ArrowCircleUpIcon)(() => `
font-size: 30px; 
@media (min-width: 600px){
   font-size: 40px; 
}
`);

export const ArrowDownIconStyled = styled(ArrowCircleDownIcon)(() => `
font-size: 30px; 
@media (min-width: 600px){
   font-size: 40px; 
}
`);

export const WrapperButtons = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
/* align-items: center; */
gap:6px;
max-width: 210px;
margin: 0 auto;
`;

export const SendIconStyled = styled(SendOutlinedIcon)(() => `
margin-left:10px;
font-size: 20px;
`);

export const DescriptionRegister = styled.p(() => `
max-width: 260px;
font-size: 14px;
margin-bottom: 10px;
@media (min-width: 600px){
font-size: 16px;
max-width: 560px;
}
`);

export const WrapperDescription = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
`;